import React, { useEffect, useState } from 'react';
import { CellProps, WithClassname } from '@jsonforms/core';
import { TextInput } from '@mantine/core';
import merge from 'lodash/merge';
import { WithInputProps } from './interfaces';
import { useDebouncedCallback } from '@mantine/hooks';

interface MantineTextInputProps {
  inputProps?: React.ComponentPropsWithoutRef<'input'>;
}

const eventToValue = (ev: any) => (ev.target.value === '' ? undefined : ev.target.value);

export const MantineInputText = React.memo(function MantineInputText(
  props: CellProps & WithClassname & MantineTextInputProps & WithInputProps
) {
  const { data, className, id, enabled, uischema, path, handleChange, config } = props;
  const appliedUiSchemaOptions = merge({}, config, uischema.options);
  const [value, setValue] = React.useState(data);

  const handleDebounceChange = useDebouncedCallback((value: string) => {
    handleChange(path, value);
  }, 200);

  const handleOnChange = (value: string) => {
    setValue(value);
    handleDebounceChange(value);
  };

  useEffect(() => {
    setValue(data);
  }, [data, setValue]);

  return (
    <TextInput
      miw={200}
      maw={320}
      id={id}
      className={className}
      value={value ?? ''}
      onChange={(event) => handleOnChange(eventToValue(event))}
      disabled={!enabled}
      autoFocus={appliedUiSchemaOptions.focus}
    />
  );
});
